import React, { Fragment } from "react";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import style from "./styles.module.scss";
import { LoadingMessage, Status } from "../Controls";
import ModalLoadFromFile from "../Modals/ModalLoadFromFile";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
const logoUrl = (symbol) => `https://storage.googleapis.com/iex/api/logos/${symbol}.png`;

const Header = ({ services, asset, mode, wizzToggle, Link }) => {
  return (
    <Card className="mb-3">
      <CardBody className="p-3">
        {mode != "new" ? (
          <Row>
            <Col lg="auto">
              {asset ? (
                <Fragment>
                  <div className={style.item}>
                    <span className={style.w55}>Ticker</span>
                    <span>{asset.AssetTicker}</span>
                  </div>
                  <div className={style.item}>
                    <span className={style.w55}>{getDefaultIdentifierLabel(asset)}</span>
                    <span>{asset.AssetDefaultIdentifierValue}</span>
                  </div>
                </Fragment>
              ) : (
                <LoadingMessage text="Loading asset" />
              )}
            </Col>
            <Col lg="auto">
              {asset && (
                <Fragment>
                  <div className={style.item}>
                    <span className={style.w120}>Name</span>
                    <span>{asset.AssetName}</span>
                  </div>
                  <div className={style.item}>
                    <span className={style.w120}>Sub asset class</span>
                    <span>{asset.SubAssetClassName}</span>
                  </div>
                </Fragment>
              )}
            </Col>
            <Col>
              <div className="d-flex">
                {asset && (
                  <div className={style.prices}>
                    <div className={style.item}>
                      <span className={style.w80}>Asset price</span>
                      <FormattedNumber
                        value={asset.AssetLast}
                        decimalScale={asset.SubAssetClassDecimalPlaces}
                        dataTypeDecimalName="price"
                      />
                    </div>
                  </div>
                )}
                {asset && (
                  <div className={style.status}>
                    <span className={style.label}>Status</span>
                    <Status status={asset.AssetStatus} />
                  </div>
                )}
              </div>
            </Col>
            <Col className="text-right">
              <Link to={`/assets/withBack`}>
                <Button color="light" className="mr-2">
                  <i className="fa fa-reply mr-1" aria-hidden="true"></i>
                  Go back
                </Button>
              </Link>
              <Button
                color="primary"
                onClick={() =>
                  wizzToggle("calculator", {
                    id: asset.AssetId,
                    price: asset.AssetLast,
                  })
                }
              >
                <i className="fa fa-calculator mr-1" aria-hidden="true"></i>
                Calculator
              </Button>
            </Col>
          </Row>
        ) : (
          <div>
            <Row>
              <Col lg="auto">
                <h4>Add new asset</h4>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <ModalLoadFromFile newAssetFromFile={services.newAssetFromFile} />
              </Col>
            </Row>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

function getDefaultIdentifierLabel(asset) {
  if (asset.AssetDefaultIdentifier != "" && asset.AssetDefaultIdentifier != "0") {
    const provider =
      asset.Synonyms && asset.Synonyms.find((s) => s.DataProviderId == asset.AssetDefaultIdentifier);

    if (provider) {
      return provider.DataProviderName;
    }
  }

  return "Not defined";
}

export default Header;
